export default "__VITE_ASSET__6164082b__"